export default __webpack_public_path__ + "static/media/ICSE Biology.06b50a80.pdf";